import type { Prototype } from "../prototype-types";

export const jabranKhanPrototypes: Prototype[] = [
  {
    id: "jk-education-hub",
    name: "Faire Education Hub",
    path: "/jk/education-hub",
    description:
      "Education hub for CMS-driven articles, step-by-step guides, and videos: featured and latest content, topic exploration, and a brand / retailer audience switch.",
    owner: "Jabran Khan",
    createdAt: "2026-10-06",
    lastUpdated: "2026-10-06",
    surfaceArea: "Other",
    project: "Faire Education Hub",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a5367938c3ce21a325fbf16a39b99b63a9cd85c6476a761c8d765c95c2d5aeae.png",
  },
];
